<div class="panel" [class]="className">
    <div class="panel-header">
        <div class="left-name">
            <span class="required-icon" *ngIf="isRequired">*</span>
            <h2 class="title">{{ title }}</h2>
        </div>
        <ng-content select="[action]"></ng-content>
    </div>
    <div class="panel-content">
        <ng-content select="[content]"></ng-content>
    </div>
</div>
